import React from 'react';
import { Box, Typography } from '@mui/material';
import { TextField } from 'ui/components/TextField/TextField';
import ColorPicker from '../ColorPicker';
import { QRCodeElementProps } from '../../../types';

interface QRCodePropertiesProps {
  selectedElement: QRCodeElementProps;
  updateElementProperty: (field: string, value: any) => void;
  handleKeyDown: (e: React.KeyboardEvent) => void;
  qrProps: { qrValue: string };
  setQrProps: React.Dispatch<React.SetStateAction<{ qrValue: string }>>;
}

const QRCodeProperties = ({
  selectedElement,
  updateElementProperty,
  handleKeyDown,
  qrProps,
  setQrProps,
}: QRCodePropertiesProps) => {
  return (
    <>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        QR Code Properties
      </Typography>
      {!selectedElement.dynamicField && (
        <TextField
          className="redesign"
          variant="standard"
          type="text"
          placeholder="Enter URL or text"
          label="QR Code Value"
          autoComplete="nope"
          name="qrValue"
          value={qrProps.qrValue}
          onChange={(e) => {
            const newValue = e.target.value;
            setQrProps((prev) => ({
              ...prev,
              qrValue: newValue,
            }));
            updateElementProperty('qrValue', newValue);
          }}
          onKeyDown={handleKeyDown}
        />
      )}
      <Box sx={{ mb: 2 }}>
        <Typography variant="body2" gutterBottom>
          QR Code Color
        </Typography>
        <ColorPicker
          color={selectedElement.fill || '#000000'}
          onChange={(color) => updateElementProperty('fill', color)}
        />
      </Box>
    </>
  );
};

export default QRCodeProperties;
